import { sanitizeTextForAnalytics } from "@/utils/helper"

export const addAdobeDataLayerGlobalVisualSearch = analytics => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState && getState("page")
  if (page) {
    const { pageInfo } = page
    if (pageInfo) {
      pageInfo["description"] =
        "KOHLER replacement parts are available for purchase. Search by product number, name, upload a photo or chat with support to find toilet parts, faucet parts and more."
      pageInfo["pageName"] = "kohler:visual search"
      pageInfo["title"] = "Visual Search | KOHLER"
    }
  }
  const {
    event,
    category,
    eventStatus,
    linkUrl,
    eventMsg,
    product,
    productCount,
    visualSearch,
  } = analytics

  const productName_ = product?.title?.text ?? product?.name
  const pdpUrl = product?.pdpUrl
  const links = linkUrl ?? window.location.href
  const productRoom = page?.category?.room

  let eventInfo = {}
  switch (event) {
    case "search_icon_click":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: "visual search:search using an image",
        eventMsg: "n/a",
        eventName: "visual search:search using an image",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "search using an image",
        internalLinkPosition: "global header:visual search",
        internalLinkType: "global navigation:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "visual search",
      }
      break
    case "category_selection":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `visual search:select your product:${category}`,
        eventMsg: eventMsg ? sanitizeTextForAnalytics(eventMsg) : "n/a",
        eventName: `visual search:select your product:${category}`,
        eventStatus: eventStatus ?? "n/a",
        eventType: "navigation",
        internalLinkName: category,
        internalLinkPosition: "global header:visual search",
        internalLinkType: "global navigation:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "visual search:select your product",
      }
      break
    case "result_page_error":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: "visual search:search results displayed",
        eventMsg: "Error in fetching results",
        eventName: "visual search:search results displayed",
        eventStatus: "failure",
        eventType: "navigation",
        internalLinkName: "<visual search results displayed>",
        internalLinkPosition: `visual search results:${category}`,
        internalLinkType: "visual search results",
        internalLinkURL: links,
        internalLinkZoneName: "visual search results",
        searchContentType: "visual search results",
        searchResult: productCount,
        searchResultCategory: "products>0",
      }
      break
    case "result_page_success":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: "visual search:search results displayed",
        eventMsg: "Image uploaded and successfully fetched results",
        eventName: "visual search:search results displayed",
        eventStatus: "success",
        eventType: "navigation",
        internalLinkName: "<visual search results displayed>",
        internalLinkPosition: `visual search results:${category}`,
        internalLinkType: "visual search results",
        internalLinkURL: links,
        internalLinkZoneName: "visual search results",
        searchContentType: "visual search results",
        searchResult: productCount,
        searchResultCategory: `products>${productCount}`,
      }
      break
    case "resultpdp_page":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction:
          "visual search:search results displayed:product navigation",
        eventMsg: "n/a",
        eventName: "visual search:search results displayed:product navigation",
        eventStatus: "success",
        eventType: "navigation",
        internalLinkName: productName_,
        internalLinkPosition: `visual search results:${category}`,
        internalLinkType: "visual search results:product tiles",
        internalLinkURL: pdpUrl,
        internalLinkZoneName:
          "visual search results:products:main content area",
      }
      break
    case "service_parts":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: "visual search:search results displayed:service parts",
        eventMsg: "Message",
        eventName: "visual search:search results displayed:service parts",
        eventStatus: "success",
        eventType: "navigation",
        internalLinkName: "service parts",
        internalLinkPosition: `visual search results:${category}`,
        internalLinkType: "visual search results:product tiles",
        internalLinkURL: "n/a",
        internalLinkZoneName:
          "visual search results:products:main content area",
      }
      break
  }

  const productInfo = product
    ? getAnalyticProductInfo(product, category, productRoom)
    : null
  if (visualSearch) productInfo.visualSearch = true

  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    ...(productInfo != null && { productInfo }),
  })
}

const getAnalyticProductInfo = (products, category, productRoom) => {
  const productInfo = {
    category: category,
    defaultImageName: products?.image?.src ?? products?.isoImageURL,
    description: sanitizeTextForAnalytics(
      products?.description?.text ?? products?.longDescription
    ),
    frequency: "n/a",
    globalDiscount: "n/a",
    globalOffer: "n/a",
    globalPromotionPrice: "n/a",
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: sanitizeTextForAnalytics(category),
    numberOfReviews: "n/a",
    pdpType: "regular finished goods",
    priceState: "regular price",
    productBasePrice: products?.price?.text ?? products?.priceing,
    productBrand: "kohler",
    productCategory: sanitizeTextForAnalytics(category),
    productCollectionsName: products?.title?.text ?? products?.name,
    productColor: "n/a",
    productCouponCode: "n/a",
    productCoupondiscount: "n/a",
    productFindingMethod: "n/a",
    productID: products?.productNumber ?? products?.productNo,
    productName: sanitizeTextForAnalytics(
      products?.title?.text ?? products?.name
    ),
    productPartnerBuyNow: "n/a",
    productRoom: productRoom,
    productSalePrice: products?.price?.text ?? products?.priceing,
    productSaleable: "n/a",
    productStatus: "n/a",
    productSuperSku: "n/a",
    productTileName: sanitizeTextForAnalytics(products?.description?.text),
    quantity: "n/a",
    ratings: "n/a",
    visualSearch: true,
  }
  return productInfo
}
